import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaAngleDoubleUp } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-dark text-white pt-5 pb-4">
      <div className="container">
        <div className="row d-flex justify-content-between align-items-start">
          {/* About Section */}
          <div className="col-lg-3 col-md-6 mb-4">
            {/* <h4 className="text-uppercase mb-3 text-success" style={{ fontSize: "18px", fontWeight: "bold" }}>
            Devi Vinayaka Builders
            </h4> */}
            <div className="brand-wordmark footer-wordmark">
              <span className="brand-name">Devi Vinayaka</span>
              <span className="brand-subtitle">Builders</span>
            </div>
            <p style={{ lineHeight: "1.6", fontSize: '14px' }}>
              Devi Vinayaka Builders helps you find the perfect
              Plot, Villa, Apartment, or House with ease. Whether you want to buy, sell,
              or invest, they understand your needs and provide the best options.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6 mb-4">
            <h5 className="text-uppercase mb-3 text-white" style={{ fontSize: "18px" }}>Quick Links</h5>
            <ul className="list-unstyled" style={{ fontSize: "15px" }}>
              <li><a href="/" className="text-white">Home</a></li>
              <li><a href="/about" className="text-white">About</a></li>
              <li><a href="/projects" className="text-white">Projects</a></li>
              <li><a href="/gallery" className="text-white">Gallery</a></li>
              <li><a href="/contact" className="text-white">Contact</a></li>
              <li><a href="/privacypolicy" className="text-white">Privacy Policy</a></li>
              <li><a href="/Termsandconditions" className="text-white">Terms & Conditions</a></li>
            </ul>
          </div>

          {/* Contact Us Section */}
          <div className="col-lg-4 col-md-6 mb-4">
            <h5 className="text-uppercase mb-3 text-white" style={{ fontSize: "18px" }}>Contact Us</h5>
            <ul className="list-unstyled" style={{ fontSize: "15px" }}>
              <li className="d-flex align-items-center gap-2 mb-3">
                <FaMapMarkerAlt className=" me-2" style={{ fontSize: "15px", color: "white" }} />
                <span>Devi vinayaka builders<br />
                  Flat no.401, Gnanambhica
                  Residency, Door no.115-14-379, Airport Road, Beside of Sanitorium, Konthamuru Rajamahendravaram Rural.</span>
              </li>
              <li className="d-flex align-items-center gap-2 mb-3">
                {/* <a href="https://api.whatsapp.com/send?phone=9848194446" target="_blank"
                rel="noopener noreferrer" className="d-flex align-items-center text-decoration-none text-white">
                  <FaPhoneAlt className=" me-2" style={{ fontSize: "15px" ,color:"white"}} /> 9848194446</a> */}

                <FaPhoneAlt className=" me-2" style={{ fontSize: "15px", color: "white" }} /><span>8977060666</span>
                <span>, 6305252452</span>
              </li>

              <li className="d-flex align-items-center gap-2  mb-3">
                <FaEnvelope className=" me-2" style={{ fontSize: "15px", color: "white" }} />
                Devi Vinayaka Builders@gmail.com
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom mt-4 d-flex justify-content-between align-items-center">
          {/* <p className="mb-0 text-white">
            
          </p> */}
          <p className="text-center text-sm text-gray-600 mt-8">
            All Rights Reserved © {currentYear} <strong>Devi Vinayaka Builders</strong>
          </p>

          <a href="#top" className="back-to-top d-inline-block text-center">
            <FaAngleDoubleUp className="d-none d-md-inline" size={24} />
            <FaAngleDoubleUp className="d-inline d-md-none" size={18} />
          </a>
        </div>
      </div>
    </footer>
  );
};
export default Footer;





